import React from 'react';
import styles from 'components/quote_builder_widget/settings/_style.module.scss';

const translate = (key) => t(`quote_builder_widget.${key}`);

// "Remove from widget", not "Remove": it only takes the item out of the widget; the owner's material or machine stays.
const AddedToWidgetCard = ({ title, children, onEdit, editDisabled, onRemove, removing, testId }) => (
  <div className={styles.addedCard} data-testid={testId}>
    <div className={styles.addedCardTitle}>{title}</div>
    {children}
    <div className={styles.addedCardActions}>
      {onEdit && (
        <button type="button" className="dct-button dct-button--secondary dct-button--small" onClick={onEdit} disabled={editDisabled}>
          <i className="fa fa-pencil" aria-hidden="true"></i>
          {translate('edit')}
        </button>
      )}
      <button type="button" className="dct-button dct-button--danger dct-button--small" onClick={onRemove} disabled={removing}>
        <i className="fa fa-minus-square-o" aria-hidden="true"></i>
        {removing ? translate('removing') : translate('remove_from_widget')}
      </button>
    </div>
  </div>
);

export default AddedToWidgetCard;
